<template>
  <div>
    <div>
      <FieldSourcePicker
        v-model="editSource"
        :title="ctrlTitle + ' Source'"
        :isRequired="isRequired"
        :modelOnly="modelOnly"
      />
    </div>
    <div
      class="pt-6"
      v-if="editSource != 'route_param' && editSource != 'row_id'"
    >
      <FieldPicker
        v-if="editSource == 'field' || editSource == 'page_field'"
        :title="ctrlTitle"
        :table="table"
        :component="component"
        :containers="containers"
        :source="editSource"
        v-model="editValue"
        @type-change="$emit('type-change', $event)"
      />
      <v-text-field
        v-else-if="editSource == 'variable'"
        filled
        v-model="editValue"
        :label="ctrlTitle"
        hide-details
      ></v-text-field>
      <ValuePicker v-else :title="ctrlTitle" :type="type" v-model="editValue" />
    </div>
  </div>
</template>

<script>
import ui from "../../../services/ui";
import FieldSourcePicker from "./FieldSourcePicker.vue";
import FieldPicker from "./FieldPicker.vue";
import ValuePicker from "./ValuePicker.vue";
import constants from "../../../helpers/constants";

export default {
  name: "FieldValuePickerBase",

  components: {
    FieldSourcePicker,
    FieldPicker,
    ValuePicker,
  },

  props: [
    "title",
    "isRequired",
    "value",
    "table",
    "containers",
    "component",
    "type",
    "modelOnly",
  ],

  data() {
    return {
      fields: [],
      dialog: false,
      editSource: constants.FIELD_SOURCE_VALUE,
      editValue: "",
      editForm: false,
    };
  },

  computed: {
    requiredRules() {
      if (this.isRequired) return [ui.requiredRule];
      return [];
    },
    ctrlTitle() {
      return this.title ?? "Value";
    },
  },

  watch: {
    value() {
      this.refresh();
    },
    editValue() {
      this.updateValue();
    },
    editSource() {
      this.updateValue();
    },
  },

  mounted() {
    this.refresh();
  },

  methods: {
    updateValue() {
      if (this.editSource == constants.FIELD_SOURCE_VALUE) {
        this.$emit("input", this.editValue);
      } else if (
        this.editSource == constants.FIELD_SOURCE_ROUTE_PARAM ||
        this.editSource == constants.FIELD_SOURCE_ROW_ID
      ) {
        this.$emit("input", this.editSource);
      } else {
        this.$emit(
          "input",
          this.editSource +
            "." +
            (this.editValue || this.editValue == false ? this.editValue : "")
        );
      }
    },
    refresh() {
      if (this.value) {
        var sa = this.value.toString().split(".");

        if (sa.length == 2) {
          this.editSource = sa[0];
          this.editValue = sa[1];
        } else if (
          this.value != constants.FIELD_SOURCE_ROW_ID &&
          this.value != constants.FIELD_SOURCE_ROUTE_PARAM
        ) {
          this.editSource = constants.FIELD_SOURCE_VALUE;
          this.editValue = this.value;
        } else {
          this.editSource = this.value;
          this.editValue = this.value;
        }
      } else {
        this.editSource = constants.FIELD_SOURCE_VALUE;
        this.editValue = this.editValue == false ? this.editValue : "";
      }
    },
  },
};
</script>
